import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField
} from '@mui/material';
import { useMutation } from '@apollo/client/react';
import { CREATE_OR_UPDATE_BOARD } from '../../graphql/boards';

const BoardFormModal = ({ open, onClose, boardId = null, onSave }) => {
  const [name, setName] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [createOrUpdateBoard] = useMutation(CREATE_OR_UPDATE_BOARD);

  useEffect(() => {
    if (!open) {
      setName('');
      setStartDate('');
      setEndDate('');
    }
  }, [open]);

  const handleSave = async () => {
    if (!name.trim()) return;

    try {
      await createOrUpdateBoard({
        variables: {
          id: boardId,
          name,
          start_date: startDate || null,
          end_date: endDate || null
        }
      });
      onSave?.();
      onClose();
    } catch (error) {
      console.error('Error saving board:', error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{boardId ? 'Edit Board' : 'Create Board'}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Board Name"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          type="date"
          margin="dense"
          label="Start Date"
          fullWidth
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{ mb: 2 }}
        />
        <TextField
          type="date"
          margin="dense"
          label="End Date"
          fullWidth
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">
          {boardId ? 'Save' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BoardFormModal;
